import { Navigate, createBrowserRouter } from "react-router-dom";
import { AppShell } from "../components/layout/AppShell";
import { AboutPage } from "../routes/AboutPage";
import { CareersPage } from "../routes/CareersPage";
import { ContactPage } from "../routes/ContactPage";
import { ControlPlanePage } from "../routes/ControlPlanePage";
import { HomePage } from "../routes/HomePage";
import { KyberDocsPage } from "../routes/KyberDocsPage";
import { NewsArticlePage } from "../routes/NewsArticlePage";
import { NewsIndexPage } from "../routes/NewsIndexPage";
import { NotFoundPage } from "../routes/NotFoundPage";
import { RapidFactoryPage } from "../routes/RapidFactoryPage";
import { SolutionsPage } from "../routes/SolutionsPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "control-plane", element: <ControlPlanePage /> },
      { path: "rapid-factory", element: <RapidFactoryPage /> },
      { path: "kyber-docs", element: <KyberDocsPage /> },
      { path: "who-we-are", element: <AboutPage /> },
      { path: "careers", element: <CareersPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "news", element: <NewsIndexPage /> },
      { path: "news/rapid-factory-ownership", element: <NewsArticlePage /> },
      { path: "about", element: <Navigate replace to="/who-we-are" /> },
      { path: "solutions", element: <SolutionsPage /> },
      { path: "*", element: <NotFoundPage /> }
    ]
  }
]);
